import React, { Component } from 'react'
import ReactDom from 'react-dom'
import cs from 'classnames';
import css from './index.css';
import { timeFormat } from '../../uilts';



const attachContainerDom = () => {
  const dom =  document.createElement('div'); 
  dom.setAttribute("id", "MessagePushPopupContianer");
  dom.setAttribute("style", " position: absolute;top: 0;bottom: 0;left: 0;right: 0;display:none");
  document.querySelector("body").appendChild(dom);
  return dom
}

const MessageItem = (props) => {
  const {name, createdAt, body, isRead, isActive, select, deleteMessage, isCanDelete} = props;
  return (
    <div 
      className={cs(css.item, {
        [css.active]: isActive
      })} 
      onClick={select}
    >
      <div className={css.itemRow}>
        <div className={css.itemTitle}>{name}
          {!isRead && <div className={css.itemNotication}></div>}
        </div>
        <div style={{flex: 1}}>
        </div>
        <div className={css.itemTime}>{timeFormat(createdAt)}</div>
      </div>
      <div className={cs(css.itemRow,css.itemRowBottom)}>
        <div className={css.itemIntro}>{body}</div>
        { 
          isCanDelete && <div className={css.itemDelete} onClick={
            (e)=> {
              e.stopPropagation(),
              deleteMessage()
            }
          }></div>
        }
      </div>
    </div>
  )
}

class MessageDeletePopup extends Component {
  constructor(props){
    super(props)
    this.state = {
      x: 0,
      y: 0,
    }
    this.deletePopupContent = {}
  }
  deletePopupContentRef = (node) => {
    this.deletePopupContent = node
  } 
  componentDidMount() {
    const { x, y } = this.props;
    const { left } = document.querySelector("#messagePushBoxRef").getBoundingClientRect()
    console.log(x, y , left)
    this.setState({
      x: x-left,
      y
    })
  } 
  render() {
    const { dismiss, deleteAll } = this.props;
    const { x, y } = this.state;
    return (
      <div className={css.deletePopupWarp} onClick={dismiss}>
        <div className={css.deletePopupContent} ref={this.deletePopupContentRef}>
          <div className={css.deletePopupBox} onClick={e => e.stopPropagation()}  style={{top: y, left: x}}>
            <div className={css.deletePopupRow}>
              <div className={css.warningIcon}></div>
              <div className={css.deletePopupTitle}>Are you sure to delete all？</div>
            </div>
            <div className={css.deletePopupRowBtn}>
              <div className={css.deletePopupBtn} onClick={dismiss}>
                Cancel
              </div>
              <div className={cs(css.deletePopupBtn,css.deletePopupBtnPrime )} onClick={deleteAll}>
                Delete
              </div>
            </div>
          </div>
        </div>
        
      </div>
    )
  }
}


class MessageList extends Component {
  constructor(props){
    super(props)
    this.state = {
      isDeleteAll: false
    }
    this.deleteBtn = {}
  }
  componentDidMount() {
    this.messagePushPopupContianer = attachContainerDom()
    const {top, left, right, bottom} = this.deleteBtn.getBoundingClientRect();
    const coordX = left - ((238-74)/2);
    const coordY = top + 24;

    //WARNING: this method was alrealy removed in react 16+, use createPortal instead 
    ReactDom.unstable_renderSubtreeIntoContainer(
      this,
      <MessageDeletePopup 
        x = {coordX}
        y = {coordY}
        dismiss = {this.dismissDeleteAllPopup}
        deleteAll = {this.deleteAll}
      ></MessageDeletePopup>,
      this.messagePushPopupContianer
    );

  }
  select = (message) => {
    const { select } = this.props;
    const { mainType } = message;
    select(mainType);
  }
  deleteBtnRef = (node) => {
    this.deleteBtn = node
  }
  
  showDeleteAllPopup = () => {
    this.setState({
      isDeleteAll: true
    })  
    this.messagePushPopupContianer.style.display = 'block';
  }

  dismissDeleteAllPopup = () => {
    this.setState({
      isDeleteAll: false
    })  
    this.messagePushPopupContianer.style.display = 'none';
  }
  deleteAll = () => {
    const { deleteAll } = this.props;
    this.dismissDeleteAllPopup()
    deleteAll()
  }
  render() {
    const { messages, active } = this.props;
    return(
      <div className={css.warp}>
        <div className={css.listTitle}>
          Message
        </div>
        <div className={css.tools}>
          <div className={css.toolbtn} onClick={()=>this.showDeleteAllPopup()} ref={this.deleteBtnRef}>
            Delete all
          </div>
          <div className={css.toolbtn} onClick={this.props.readAll}>
            Read all
          </div>
        </div>
        { messages.length !== 0 
        
          ? messages.map((message)=>{
            return {
              ...message,
              isActive: message.mainType === active
            }
          }).map((message)=> {
            return (
              <MessageItem
                {...message}
                select={()=>this.select(message)}
                deleteMessage={()=>this.props.deleteMessage(message.mainType)}
              />
            )
          })
          : <div className={css.empty}>
            <div className={css.emptyTitle}>No Messages</div>
            <div className={css.emptyMessage}>You don’t have any messages</div>
          </div>
        }
      </div>
    )
  }
}

export default MessageList


// WEBPACK FOOTER //
// ./src/pages/MessagePush/compontents/MessageList/index.js